import { render, staticRenderFns } from "./ViewRequestDetailModal.vue?vue&type=template&id=d6349cdc"
import script from "./ViewRequestDetailModal.vue?vue&type=script&lang=ts"
export * from "./ViewRequestDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports